import { useEffect, useState } from "react";
import { requestNotificationPermission } from "../firebase/firebase.config";
import axios from "axios";
import helpers from "../components/helpers/helpers";

export const useFCM = () => {
  const [fcmToken, setFCMToken] = useState(null);
  const [error, setError] = useState(null);
  const { apiUrl } = helpers;

  const updateFCMToken = async (token) => {
    try {
      const sessionToken = sessionStorage.getItem("token");
      const authToken = sessionToken
        ? JSON.parse(sessionToken)?.accessToken
        : null;

      const response = await axios.post(
        `${apiUrl}/user/fcm-token`,
        { fcmToken: token },
        {
          headers: {
            Authorization: authToken ? `Bearer ${authToken}` : undefined,
          },
        }
      );

      if (response.status === 200) {
        localStorage.setItem("fcmToken", token);
      }
    } catch (err) {
      if (err.response?.status === 401) {
        // Store token in localStorage if unauthorized
        localStorage.setItem("pendingFCMToken", token);
      }
    }
  };

  useEffect(() => {
    const initializeFCM = async () => {
      try {
        // Always wait 2 minutes before requesting notification permission
        await new Promise((resolve) => setTimeout(resolve, 2 * 60 * 1000));

        const token = await requestNotificationPermission();
        setFCMToken(token);
        await updateFCMToken(token);
      } catch (err) {
        setError(
          err instanceof Error ? err.message : "Failed to initialize FCM"
        );
      }
    };

    initializeFCM();
  }, []);

  return { fcmToken, error };
};
